import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ColumnSorting, sortingDirection } from 'src/app/core/models/common/column-sorting.model';



@Component({
    selector: 'app-dashboard-sorting-button',
    templateUrl: './dashboard-sorting-button.component.html',
    styleUrls: ['./dashboard-sorting-button.component.scss'],
    standalone: false
})
export class DashboardSortingButtonComponent implements OnInit {

  @Input() sortingColumns: string[] = []
  @Input() boardName!: string

  @Output() columnSorting = new EventEmitter<ColumnSorting | null>()

  sortingColumn: string | null = null
  sortingDirection: sortingDirection | null = null

  constructor() { }

  ngOnInit(): void {
  }

  onColumnButtonClick(column: string) {
    const direction = this.getNextSortingDirectionState(column)

    this.sortingDirection = direction
    this.sortingColumn = direction ? column : null

    if (direction) this.columnSorting.emit({ columnName: column, sortingDirection: direction })
    else this.columnSorting.emit(null)
  }

  getNextSortingDirectionState(column: string): sortingDirection | null {
    if (column != this.sortingColumn) return 'up'

    switch (this.sortingDirection) {
      case null: return 'up'
      case 'up': return 'down'
      case 'down': return null
    }
  }

}
